'use strict';

class Notice {

    constructor(state, message) {
        this.message = message;
        this.state = state;
    }

    showNotice() {        
        let title = 'Ошибка';
        let type = 'error';
        if (this.state === true) {
            title = this.message;
            this.message = '';
            type = 'success';            
        }
        Swal.fire(title, this.message, type);

    }

}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Notice;
}